<script setup>
import { defineProps, ref } from 'vue';

// props
defineProps(['title', 'classes']);

// refs
const active = ref(false);

// methods
function toggle() {
    active.value = !active.value;
}
</script>

<template>
    <div class="simple-spoiler-item-container {{classes}}" :class="{'simple-spoiler-active': active }">
        <div class="simple-spoiler-item-title" @click="toggle">
            <div class="simple-spoiler-title-text">
                {{title}}
            </div>
            <span class="simple-spoiler-toggle">
                <span class="icon-more">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <line x1="8" y1="7" x2="16" y2="12" stroke="black" stroke-width="1" />
                        <line x1="8" y1="17" x2="16" y2="12" stroke="black" stroke-width="1" />
                    </svg>
                </span>
                <span class="icon-less">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <line x1="7" y1="8" x2="12" y2="16" stroke="black" stroke-width="1" />
                        <line x1="17" y1="8" x2="12" y2="16" stroke="black" stroke-width="1" />
                    </svg>
                </span>
            </span>
        </div>
        <div class="simple-spoiler-item-body">
            <div class="simple-spoiler-body-text">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<style scoped>
/*.simple-spoiler-container {
    font-family: 'Garamond Premiere Pro';
}*/
.simple-spoiler-item-container {
    border-top: 1px solid #444;
    border-bottom: 1px solid #444;
}
.simple-spoiler-item-title {
    padding-bottom: 12px;
    padding-top: 12px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-weight: 400;
    color: #000;
}
.simple-spoiler-item-title:hover .simple-spoiler-title-text {
    color: #545454;
}

.simple-spoiler-item-title .simple-spoiler-toggle, .simple-spoiler-item-title .simple-spoiler-toggle svg {
    width: 32px;
    height: 32px;
}
.simple-spoiler-item-title .simple-spoiler-toggle svg polygon {
    fill: #444;
}
.simple-spoiler-item-title:hover .simple-spoiler-toggle svg polygon {
    fill: #545454;
}
.simple-spoiler-item-body {
    box-sizing: border-box;
    max-height: 0px;
    overflow: hidden;
    transition: padding .2s cubic-bezier(.165,.84,.44,1) .3s, height .5s cubic-bezier(.165,.84,.44,1), max-height .5s cubic-bezier(.165,.84,.44,1);
}
.simple-spoiler-active .simple-spoiler-item-body {
    max-height: 5000px;
    transition: padding .2s cubic-bezier(1,0,0,1), height 1s cubic-bezier(1,0,0,1), max-height 1s cubic-bezier(1,0,0,1);
}

.simple-spoiler-item-container .icon-less, .simple-spoiler-item-container.simple-spoiler-active .icon-more {
    display: none;
}
.simple-spoiler-item-container.simple-spoiler-active .icon-less, .simple-spoiler-item-container .icon-more {
    display: inline-block;
}
.simple-spoiler-item-body {
    font-weight: 400;
}
.simple-spoiler-body-text {
    opacity: 0;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 24px;
    padding-top: 24px;
    transform: translateY(32px);
    transition: opacity .2s cubic-bezier(.895,.03,.685,.22),transform .2s cubic-bezier(.895,.03,.685,.22);
}
.simple-spoiler-item-container.simple-spoiler-active .simple-spoiler-body-text {
    opacity: 1;
    transform: translateY(0);
    transition: opacity .2s cubic-bezier(.165,.84,.44,1) .2s,transform .3s cubic-bezier(.165,.84,.44,1) .2s;
}
</style>
